import React from 'react';

const QuestionMark = ({ hint }) => {
  return (
    <span className="help-tooltip-wrapper">
      <i className="fe-help-circle" />
      <span className="help-tooltip">{hint}</span>
    </span>
  );
};

export default QuestionMark;
